export const mapResponse = (response) => {
  return response.data;
}
